// Table Sort

const initSortableTables = (container = document) => {
  container.querySelectorAll('[data-sort-table]').forEach((table) => {
    if (table?.dataTable) {
      table.dataTable.destroy();
      table.dataTable = null;
    }

    table.dataTable = new simpleDatatables.DataTable(table, {
      searchable: false,
      paging: false,
      perPageSelect: false,
      labels: {
        perPage: '',
        noRows: '',
        info: '',
      },
    });
  });
};

initSortableTables();

// *******************************************************************************
// Axios with Filter and Search
// *******************************************************************************

const listSearchModule = document.querySelector('.list-with-search');

if (listSearchModule) {
  // Axios function
  const axiosGetFilteredAndSearchPosts = async (parent, formsData = {}) => {
    const action = parent.querySelector('[data-action]').value;
    const formDataInput = {
      action,
      id: localData.id,
      ...formsData,
    };

    const noResultElem = parent.querySelector('[data-not-found]');
    const loadMoreElem = parent.querySelector('[data-load-more]');
    const table = parent.querySelector('[data-sort-table]');

    loadMoreElem?.classList.add('is-disabled');
    parent.classList.add('show-loader');

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);

      if (table?.dataTable) {
        table.dataTable.destroy();
        table.dataTable = null;
      }

      const innerElem = parent.querySelector('.list-with-search__inner tbody');
      innerElem.innerHTML = '';

      if (innerElem && data.data.html_list) {
        innerElem.innerHTML = data.data.html_list;

        initSortableTables(parent);

        parent.classList.remove('no-result-found');
        noResultElem.classList.add('hide');
      }

      if (noResultElem && !data.data.html_list) {
        parent.classList.add('no-result-found');
        noResultElem.classList.remove('hide');
      }

      parent.classList.remove('show-loader');
      updateUrl({ formsData });

      window.scrollTo(parent);
    } catch (err) {
      console.error(err);
      parent.classList.remove('show-loader');
    }
  };

  const updateUrl = ({ formsData }) => {
    const url = new URL(window.location.href);
    if (formsData.searchTerm) {
      url.searchParams.set('searchTerm', formsData.searchTerm);
    } else {
      url.searchParams.delete('searchTerm');
    }
    if (formsData.location) {
      url.searchParams.set('location', formsData.location);
    } else {
      url.searchParams.delete('location');
    }

    window.history.pushState({}, '', url.toString());
  };

  const getFormsData = (parent) => ({
    location: getCheckedRadio(parent, 'country_dropdown'),
    searchTerm: getSearchedData(parent),
  });

  // Filter click
  attachEvent('.list-with-search .mod-filter__row input[name="country_dropdown"]', 'click', (ev) => {
    const parent = ev.target.closest('.list-with-search');
    axiosGetFilteredAndSearchPosts(parent, getFormsData(parent));
  });

  // Search
  const searchInput = listSearchModule.querySelector('.mod-filter .mod-input__field');
  searchInput.addEventListener('keydown', (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      const parent = ev.target.closest('.list-with-search');
      axiosGetFilteredAndSearchPosts(parent, getFormsData(parent));
    }
  });

  attachEvent('.list-with-search .search_button', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.list-with-search');
    axiosGetFilteredAndSearchPosts(parent, getFormsData(parent));
  });
}
